import React from 'react';
import { Box, Grid } from '@material-ui/core';
import TitleText from './TitleText';
import BodyText from './BodyText';
const TBOSummaryRow = ({ i, index, location, timeConvert, matches }) => {
	return (
		<>
			<Box
				display='flex'
				justifyContent='space-between'
				mt={index > 0 ? '20px' : ''}>
				<Box display='flex' alignItems='center'>
					<Box alignItems='center' display='flex'>
						<TitleText
							textStyle={{
								fontFamily: 'unset',
								fontWeight: 500,
								fontSize: 18,
							}}>
							{i.Origin.Airport.CityCode}
						</TitleText>
						-
						<TitleText
							textStyle={{
								fontFamily: 'unset',
								fontWeight: 500,
								fontSize: 18,
							}}>
							{index == 0
								? location.state.OneflightData.Segments[0]
										.filter((i, ind) => ind === 0)
										.map((one) => {
											return one.Destination.Airport.CityCode;
										})
								: index == 1
								? location.state.OneflightData.Segments[0]
										.filter((i, ind) => ind === 1)
										.map((one) => {
											return one.Destination.Airport.CityCode;
										})
								: index == 2
								? location.state.OneflightData.Segments[0]
										.filter((i, ind) => ind === 2)
										.map((one) => {
											return one.Destination.Airport.CityCode;
										})
								: ''}
						</TitleText>
					</Box>
					{index === 0 ? (
						<Box
							ml={'30px'}
							style={{
								background: 'rgb(239, 51, 57)',
								padding: '3px 15px',
								borderRadius: '50px',
								color: 'white',
								fontFamily: 'unset',
								fontWeight: 500,
							}}>
							<TitleText two>ONWARD</TitleText>
						</Box>
					) : (
						''
					)}
				</Box>
				<Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
			</Box>
			<Box mt={'20px'}>
				<BodyText three textStyle={{ fontSize: 16 }}>
					{' '}
					{`${new Date(
						location.state.body.Segments[0].PreferredDepartureTime
					).toLocaleString('en-us', {
						weekday: 'short',
					})} ,  ${new Date(
						location.state.body.Segments[0].PreferredDepartureTime
					).getDate()} ${new Date(
						location.state.body.Segments[0].PreferredDepartureTime
					).toLocaleString('en-us', {
						month: 'short',
					})},2022`}
				</BodyText>
			</Box>
			<Box
				style={{
					background: 'white',
					padding: '10px 15px',
					border: '1px solid #e6e6e6',
					marginTop: '10px',
					borderRadius: 5,
				}}>
				<Grid container style={{ alignItems: 'center' }}>
					<Grid item xs={12} sm={3} lg={3}>
						<Box
							display={matches ? 'flex' : ''}
							justifyContent={matches ? 'space-between' : ''}
							alignItems={matches ? 'center' : ''}>
							<TitleText
								textStyle={{
									fontFamily: 'unset',
									fontWeight: 500,
									fontSize: 18,
								}}>
								{i.Origin.Airport.CityName}
								{/* {i.Origin.Airport.AirportCode}) */}
							</TitleText>
							<TitleText
								three
								textStyle={{
									fontFamily: 'unset',
									fontWeight: 600,
									fontSize: matches ? 16 : '',
								}}>
								{i.Origin.DepTime.substr(11, 5)}
							</TitleText>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={3}
						lg={3}
						style={{ marginTop: matches ? 10 : '' }}>
						<Box
							style={{
								padding: '2px 20px',
								background: 'rgb(239, 51, 57)',
								color: 'white',
								borderRadius: 25,
							}}>
							<BodyText
								three
								textStyle={{
									fontSize: 16,
									textAlign: 'center',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}>
								{timeConvert(i.Duration)}
							</BodyText>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={3}
						lg={3}
						style={{
							textAlign: 'center',
							marginTop: matches ? 10 : '',
						}}>
						<Box
							display={matches ? 'flex' : ''}
							justifyContent={matches ? 'space-between' : ''}
							alignItems={matches ? 'center' : ''}>
							<TitleText
								textStyle={{
									fontFamily: 'unset',
									fontWeight: 500,
									fontSize: 18,
								}}>
								{i.Destination.Airport.CityName}
								{/* {i.Destination_City} */}
								{/* {i.Origin.Airport.AirportCode}) */}
							</TitleText>
							<TitleText
								three
								textStyle={{
									fontFamily: 'unset',
									fontWeight: 500,
									fontSize: matches ? 16 : '',
								}}>
								{i.Destination.ArrTime.substr(11, 5)}
							</TitleText>
						</Box>
					</Grid>
					<Grid item xs={12} sm={3} lg={3} style={{ textAlign: 'center' }}>
						<img
							src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
							width='50px'
							height='25px'></img>
						<p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export default TBOSummaryRow;
